import { useEffect, useState } from "react";

import { LoadingShim } from "@narmi/design_system";

import SignedUrlIframe from "../../../../components/SignedUrlIframe";

import type { SignedUrlIframeProps } from "../../../../components/SignedUrlIframe";

type SignedUrlIframePageProps = Omit<
  SignedUrlIframeProps,
  "setError" | "onLoad"
>;

const SignedUrlIframePage = (props: SignedUrlIframePageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const stopLoading = () => setIsLoading(false);

  useEffect(() => {
    // Backstop: some failures never fire the iframe's load event (e.g. a refused connection in Firefox)
    const timeout = setTimeout(() => setIsLoading(false), 30_000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <LoadingShim isLoading={isLoading}>
      <div style={isLoading ? { minHeight: props.height } : undefined}>
        <SignedUrlIframe
          {...props}
          setError={stopLoading}
          onLoad={stopLoading}
        />
      </div>
    </LoadingShim>
  );
};

export default SignedUrlIframePage;
